var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{staticClass:"company-list-modal",attrs:{"name":"company-list-modal","title":_vm.title,"hide-footer":""},on:{"before-open":_vm.beforeOpen}},[_c('div',{staticClass:"customer-list"},[_c('app-list-items',{attrs:{"list-items":_vm.companies},on:{"on-click":_vm.onClick}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f19f1400","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/customer/company-list-modal.vue
// module id = ZNGy
// module chunks = 23